import Icon from "./Icon";
import { siteDetails } from "../siteContent";

const Vacancies = () => (
  <section aria-labelledby="careers-title" className="career-strip" id="careers">
    <div className="container career-strip__inner">
      <div className="career-strip__icon">
        <Icon name="people" size={30} />
      </div>
      <div className="career-strip__copy">
        <p className="eyebrow">Work with us</p>
        <h2 id="careers-title">Interested in joining the Ascot Lodge team?</h2>
        <p>
          Vacancies change over time. Contact the home to ask about current
          opportunities and how to apply.
        </p>
      </div>
      <div className="career-strip__actions">
        <a className="button button--light" href="#contact">
          Careers enquiry
          <Icon name="arrow" size={19} />
        </a>
        <a className="career-strip__phone" href={siteDetails.phoneHref}>
          <Icon name="phone" size={19} />
          {siteDetails.phoneDisplay}
        </a>
      </div>
    </div>
  </section>
);

export default Vacancies;
